export default __webpack_public_path__ + "static/media/laurentienne-logo.5e42e054.svg";